<script setup lang="ts">
import PanelGroup from '../PanelGroup.vue'

import { Field } from 'vee-validate'

import InputCaracterCounter from '@/components/InputCaracterCounter.vue'
import ImageUploaderNew from '@/components/ui/ImageUploader/ImageUploaderNew.vue'
import RecoveryPanel from './loyalty/RecoveryPanel.vue'

import type { ImageFile } from '@/types/types'
import type { LoyaltyMerchantFormTexts } from '@/types/global'
import type { PanelTab } from '../../lib/brandAppSections'

defineProps<{
  images: ImageFile[]
  initialImages: ImageFile[]
  deletedImages: number[]
  tab?: PanelTab
}>()

const emit = defineEmits<{
  (e: 'update:images', value: string[]): void
  (e: 'update:deleted-images', value: number[]): void
}>()

const { t } = useI18n()
const { merchantTextsForm } = useMerchantTexts()

const fieldLabels = computed<Record<keyof LoyaltyMerchantFormTexts['webappTextsFields'], string>>(() => ({
  webappHomeTitle: t('pages.loyaltySupports.webapp.editor.loyalty.homeTitle'),
  webappHomeSubtitle: t('pages.loyaltySupports.webapp.editor.loyalty.homeSubtitle')
}))
</script>

<template>
  <div class="flex flex-col">
    <PanelGroup v-if="tab !== 'content'" :title="t('pages.loyaltySupports.webapp.editor.loyalty.textsGroup')">
      <div class="flex flex-col gap-5">
        <div class="grid grid-cols-2 gap-5">
          <div v-for="(field, index) in merchantTextsForm.webappTextsFields" :key="index" class="flex flex-col gap-2">
            <label :for="field.label" class="text-foreground block text-sm font-medium">{{ fieldLabels[index] }}</label>
            <Field
              :id="field.label"
              v-model="field.value"
              :type="field.type"
              :name="field.label"
              as="textarea"
              class="border-input focus:border-primary focus:ring-primary block w-full rounded-md border px-3 focus:outline-hidden sm:text-sm"
              :rules="field.rules"
            />
            <InputCaracterCounter
              v-if="field.maxLength"
              :content="field.value"
              :max-length="field.maxLength"
              @truncate-content="field.value = $event"
            />
          </div>
        </div>
      </div>
    </PanelGroup>

    <PanelGroup v-if="tab !== 'text'" :title="t('pages.loyaltySupports.webapp.editor.loyalty.teasingImages')">
      <ImageUploaderNew
        :images="images"
        :initial-images="initialImages"
        :deleted-images="deletedImages"
        :aspect-ratio="[9, 16]"
        :ratio-name="t('pages.loyaltySupports.webapp.editor.loyalty.storyFormat')"
        @update:images="emit('update:images', $event)"
        @update:deleted-images="emit('update:deleted-images', $event)"
      />
    </PanelGroup>

    <PanelGroup v-if="tab !== 'text'" :title="t('pages.loyaltySupports.webapp.editor.loyalty.recoveryGroup')">
      <RecoveryPanel />
    </PanelGroup>
  </div>
</template>
